// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadBlock_root__5faFC","container":"UploadBlock_container__R3O9m","button":"UploadBlock_button__25b2r","icon":"UploadBlock_icon__fZnuP"};